import React from 'react';

export const getFontSize = (size: number | undefined): React.CSSProperties => (size ? { fontSize: `${size}px` } : {});
